import React, { forwardRef } from 'react';
import MUILink, { LinkProps as MUILinkProps } from '@material-ui/core/Link';

interface LinkProps extends MUILinkProps {}

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  const { underline = 'none', ...rest } = props;

  return <MUILink {...rest} ref={ref} underline={underline} />;
});

Link.displayName = 'Link';

export default Link;
